import React from 'react';
import ContentLinkRenderer from "../ContentLinkRenderer/ContentLinkRenderer";
import PropTypes from 'prop-types';

const newsWidget = (props) => {
  return (
    <ul className="unstyled-list basic-two-columns__feed-list">
      {
        props.news
          .filter((item, index) => {
            return index < (props.displayAmount ? props.displayAmount : 5)
          })
          .map((item, index) => {
            return (
              <li key={index} className="basic-two-columns__feed-item">
                <ContentLinkRenderer
                  contentType={item.detailContent.type}
                  value={item.detailContent.value}
                  linkContent={item.title}
                  className={`basic-two-columns__feed-link ${props.linkColorClass ? props.linkColorClass : ''}`}
                  target={item.detailContent.target}
                  pathForItem="/about/news/news-item"
                  id={item.id}
                  onEmptyContent={<p className={`basic-two-columns__text mtn ${props.linkColorClass ? props.linkColorClass : ''}`}>{item.title}</p>}
                />
              </li>
            )
          })
      }
    </ul>
  )
};

export default newsWidget;

newsWidget.propTypes = {
  news: PropTypes.any,
  linkColorClass: PropTypes.string,
  displayAmount: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/components/NewsWidget/NewsWidget.js